import React, { FC } from 'react';
import HyperLink from '../common/HyperLink';

const POQuantityDisplay: FC<any> = ({ quantity, stockLocationId, partId }): React.ReactElement => {
	return (
		<div>
			{quantity ? (
				<HyperLink
					text={quantity}
					newTabPath={`/supplier/purchaseOrders/overview/orders?stockLocationIds=${stockLocationId}&partIds=${partId}&statuses=${encodeURIComponent(
						'ordered,new,partially_received'
					)}`}
				/>
			) : (
				0
			)}
		</div>
	);
};

export default POQuantityDisplay;
